module.exports = __webpack_public_path__ + "static/BT-mobile-15-2007b51ff8ac623f9311ae5af505d4fa.jpg";